'use strict';

// http://www.w3.org/TR/html5/forms.html#valid-e-mail-address
var EMAIL_RE = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

function isValidEmail(email) {
  return EMAIL_RE.test(email);
}

module.exports = isValidEmail;


/** WEBPACK FOOTER **
 ** ./utils/isValidEmail.js
 **/